import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=ec08b624&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=ec08b624&prod&lang=css"
import style1 from "./PurchaseOrder.vue?vue&type=style&index=1&id=ec08b624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec08b624",
  null
  
)

export default component.exports